import { DestroyRef, Pipe, PipeTransform, inject } from '@angular/core';
import { StockService } from './stock.service';
import { map, Observable } from 'rxjs';
import { StockMap } from '@pedix-workspace/shared-stock';
import { toObservable, takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Pipe({
  name: 'pxwStockIsOutOfStock',
  standalone: true,
})
export class StockIsOutOfStockPipe implements PipeTransform {
  private stockService = inject(StockService);
  private destroyRef = inject(DestroyRef);

  stock$: Observable<StockMap>;

  constructor() {
    this.stock$ = toObservable(this.stockService.stock);
  }

  transform(product: {
    id: string;
    presentations?: { items?: readonly { id: string }[] } | null;
  }): Observable<boolean> {
    return this.stock$.pipe(
      takeUntilDestroyed(this.destroyRef),
      map(stock => {
        if (product.presentations) {
          return (
            product.presentations?.items?.every(
              item => stock.getStockInfoByItem(item.id).isOutOfStock,
            ) || false
          );
        } else {
          return stock.getStockInfoByItem(product.id).isOutOfStock;
        }
      }),
    );
  }
}
